module.exports = __webpack_public_path__ + "static/media/comment.09bd1c08.svg";